import { isTextNode, isOneOfTags } from 'anodum';
import splitElement from './clipboard-insertion/split-element';
import findNextTextContent from './find-next-text-content';
import findPrevTextContent from './find-prev-text-content';
import { IMAGE_TAG, LIST_ELEMENTS } from '../constants/editable-elements';
import { IMAGE_SELECTOR } from '../../hdrm/constants/image-selector';
import hasNodeContent from '../verifiers/has-node-content';

const generateFakeSelectionData = (node) => {
  if (isTextNode(node)) {
    return { node, offset: node.data.length };
  }
  return { node, offset: 0 };
};

const makeElementRootPosition = (element, rootElement) => {
  if (!isOneOfTags(element, [IMAGE_SELECTOR, IMAGE_TAG])) return;
  const ancestorElement = Array.from(rootElement.children).find((child) => child.contains(element));
  const nextTextNode = findNextTextContent(element, ancestorElement);
  const prevTextNode = findPrevTextContent(element, ancestorElement);

  if (nextTextNode && !prevTextNode) {
    ancestorElement.parentNode.insertBefore(element, ancestorElement);
  }

  if (!nextTextNode && prevTextNode) {
    ancestorElement.parentNode.insertBefore(element, ancestorElement.nextElementSibling);
  }

  if (nextTextNode && prevTextNode) {
    const leftPart = splitElement(ancestorElement, generateFakeSelectionData(prevTextNode));
    const { ownerDocument: liveDocument } = element;
    const fragment = liveDocument.createDocumentFragment();
    fragment.append(leftPart, element);
    ancestorElement.parentNode.insertBefore(fragment, ancestorElement);
  }

  if (!nextTextNode && !prevTextNode) {
    ancestorElement.parentNode.insertBefore(element, ancestorElement);
  }

  if (isOneOfTags(ancestorElement, LIST_ELEMENTS)) {
    Array.from(ancestorElement.children).forEach((listItem) => {
      if (!hasNodeContent(listItem)) {
        listItem.remove();
      }
    });
  }

  if (!hasNodeContent(ancestorElement)) {
    ancestorElement.remove();
  }
};

export default makeElementRootPosition;
